import(/* webpackMode: "eager" */ "D:\\FekerTech\\Shahen Website New\\src\\components\\loading-screen\\loading-screen.jsx");
;
import(/* webpackMode: "eager" */ "D:\\FekerTech\\Shahen Website New\\src\\components\\loading-screen\\splash-screen.jsx");
